module.exports = {"341322100":"龙城镇","341322101":"黄口镇","341322102":"杨楼镇","341322103":"闫集镇","341322104":"新庄镇","341322105":"刘套镇","341322106":"马井镇","341322107":"大屯镇","341322108":"赵庄镇","341322109":"杜楼镇","341322110":"丁里镇","341322111":"王寨镇","341322112":"祖楼镇","341322113":"青龙集镇","341322114":"张庄寨镇","341322115":"永堌镇","341322116":"白土镇","341322117":"官桥镇","341322200":"圣泉乡","341322201":"酒店乡","341322202":"孙圩子乡","341322203":"庄里乡","341322204":"石林乡","341322400":"萧县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341322.json
// module id = 1039
// module chunks = 0